import hasAlreadyConsented from "../../../hasAlreadyConsented";

export default class EventsMap {
    static init() {
        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }

        let elements = document.querySelectorAll('neos-events');
        if (!elements.length) {
            return;
        }

        Array.from(elements).forEach(el => {
            new EventsMap(el);
        });
    }

    constructor(el) {
        const initialMessageEl = el.querySelector('.neos-events__initial-message');
        if (!initialMessageEl) {
            return;
        }

        if (!hasAlreadyConsented('preference')) {
            initialMessageEl.innerHTML = 'Bitte <a href="#CCM.openWidget">akzeptiere Funktionalitäts-Cookies</a> um die Event-Karte anzeigen zu können.';
            return;
        }

        const hasEventId = !!el.dataset.eventId;
        if (hasEventId) {
            initialMessageEl.innerHTML = 'Event wird geladen...';
            return;
        }

        initialMessageEl.innerHTML = 'Events-Übersicht wird geladen...';
    }
}
